import $ from 'jquery';

export const productGrid = () => {
  const $productGrid = $('.product-grid');
  const $techniqueSelect = $productGrid.find('.select-technique');
  const $materialSelect = $productGrid.find('.select-material');
  const $loadButton = $('.load-more-products');
  const $parent = $productGrid.data('post-id');
  const $productCount = $productGrid.find('.tease-product').length;

  if ($productGrid && $productCount < 12) {
    $productGrid.find('.results__cta').remove();
  }

  let page = 1;

  $techniqueSelect.on('change', (e) => {
    getRequest($techniqueSelect.val(), $materialSelect.val());
  });

  $materialSelect.on('change', (e) => {
    getRequest($techniqueSelect.val(), $materialSelect.val());
  });

  const getRequest = (technique, material) => {
    $.ajax({
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      dataType: 'html',
      data: {
        action: 'get_products',
        get_page: page,
        technique: technique,
        material: material,
        parent: $parent,
      },
      success: function (data) {
        $productGrid.find('.results__cta').remove();

        $('.product-results__container').replaceWith(
          `<div class="results-container product-results__container">${data}</div>`
        );
      },
      error: function (data) {
        console.log(data);
      },
    });
  };

  $loadButton.on('click', function (e) {
    e.preventDefault();
    page++;

    $.ajax({
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      dataType: 'html',
      data: {
        action: 'get_more',
        get_page: page,
        post_type: 'product',
        grid: true,
        parent: $parent,
      },
      success: function (data) {
        if ($('<div></div>').html(data).find('.ended').length > 0)
          $('.results__cta').remove();
        else $('.results__cta').show();
        $(`.product-results__container`).append(data);
      },
      error: function (data) {
        console.log(data);
      },
    });
  });
};
